import { render } from "./DesignComparison.vue?vue&type=template&id=5462f09f&scoped=true"
import script from "./DesignComparison.vue?vue&type=script&lang=js"
export * from "./DesignComparison.vue?vue&type=script&lang=js"

import "./DesignComparison.vue?vue&type=style&index=0&id=5462f09f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5462f09f"]])

export default __exports__